import moment from 'moment';
import { formatDateTime } from 'src/pages/kds';

export const kotPrint = (props: any) => {
  const items = props.ordersItems || props.items;
  return (
    <div>
      <div
        id={`startprintKOT${props.id}`}
        className="hidden"
        style={{ fontFamily: 'Arial', color: '#000' }}
      >
        <div
          className="w-[100%] h-[100%]"
          style={{
            display: 'flex',
            flexDirection: 'column',
            fontFamily: 'Arial',
            fontWeight: '400',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <span
              style={{
                fontSize: '16px',
                lineHeight: '18px',
                marginBottom: '5px',
              }}
            >
              KOT / BOT
            </span>
          </div>
          <span
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginTop: '10px',
              fontSize: '12px',
              lineHeight: '14px',
              marginBottom: '5px',
            }}
          >
            <span>
              Time: {formatDateTime(new Date(props?.createdAt || ''))}
            </span>
          </span>
          <span
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginTop: '10px',
              fontSize: '12px',
              lineHeight: '14px',
              marginBottom: '5px',
            }}
          >
            <span> Table: {props?.tableName || props?.table?.name}</span>
          </span>
          <span
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginTop: '10px',
              fontSize: '12px',
              lineHeight: '14px',
              marginBottom: '5px',
            }}
          >
            <span> Order No.: #{props?.referenceNumber}</span>
          </span>
          <div
            style={{
              display: ' grid',
              gridTemplateColumns: 'repeat(4, 1fr)',
              marginBottom: '10px',
              marginTop: '10px',
              paddingTop: '10px',
              paddingBottom: '10px',
              fontSize: '12px',
              lineHeight: '14px',
              borderTop: '2px solid #000',
              borderBottom: '2px solid #000',
              textTransform: 'uppercase',
            }}
          >
            <div style={{ gridColumn: 'span 3' }}>Item</div>
            <div>Qty</div>
          </div>

          <div style={{}}>
            {items?.map((each: any, i: number) => {
              return (
                <div
                  style={{
                    display: ' grid',
                    gridTemplateColumns: 'repeat(4, 1fr)',
                    marginBottom: '10px',
                    fontSize: '12px',
                    lineHeight: '14px',
                  }}
                >
                  <div style={{ gridColumn: 'span 3' }}>
                    {each.hasVariants
                      ? `${each.itemName || each.name} (${each.variantName})`
                      : `${each.itemName || each.name}`}{' '}
                    {each.selectedModifiers &&
                    each.selectedModifiers.length > 0 ? (
                      <div
                        style={{
                          marginLeft: '10px',
                        }}
                      >
                        {each.selectedModifiers.map((mod: any, i: any) => (
                          <div
                            key={i}
                            style={{
                              marginLeft: '10px',
                              marginTop: '5px',
                            }}
                          >
                            <span
                              style={{
                                fontWeight: '500',
                              }}
                            >
                              {mod.name}
                            </span>
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                                marginLeft: '10px',
                              }}
                            >
                              {mod?.options?.map(
                                (eachOp: any, indOp: number) =>
                                  eachOp.hasSelected && (
                                    <div
                                      key={mod.name + indOp + eachOp.name}
                                      style={{
                                        display: eachOp.hasSelected
                                          ? 'flex'
                                          : 'hidden',
                                      }}
                                    >
                                      {eachOp.name}
                                    </div>
                                  )
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      ''
                    )}
                    {each?.spiceLevel && (
                      <div
                        style={{
                          display: 'flex',
                          marginLeft: '10px',
                          marginTop: '5px',
                        }}
                      >
                        <span>Spice level - </span>
                        <span>{each.spiceLevel}</span>
                      </div>
                    )}
                    {each.note !== null && each.note ? (
                      <div
                        style={{
                          display: 'flex',
                          marginLeft: '10px',
                          marginTop: '5px',
                        }}
                      >
                        <span
                          style={{
                            fontWeight: '700',
                            fontSize: '12px',
                            lineHeight: '16px',
                            color: '#6D6D6D',
                          }}
                        >
                          Note:{' '}
                        </span>
                        <span
                          style={{
                            fontWeight: '400',
                            fontSize: '12px',
                            lineHeight: '18px',
                            color: '#6D6D6D',
                          }}
                        >
                          {each?.note}
                        </span>
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                  <div>{each.quantity}</div>
                </div>
              );
            })}
          </div>
        </div>
        <br />
        <br />
      </div>
    </div>
  );
};
